/**
 * Created by Ning Jiang on 2021-06-18.
 */

import {TimelineLite, gsap} from "gsap";
import {MathHelper} from "../../../../core/utils/MathHelper";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {KarenGameAssets} from "../../../KarenGameAssets";
import {KarenLayers, Layers} from "../../../view/KarenLayers";
import {Translator} from "../../../../core/config/translate/Translator";
import {TranslationTexts} from "../../../../core/config/translate/TranslationTexts";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {KarenTextStyles} from "../../../KarenTextStyles";
import {Karen} from "../../../Karen";
import {IBetWayWinData} from "../../../server/data/IKarenData";

export class InitialWinCountUp extends PIXI.Container {

    protected _countUp: BitmapCountUp;
    private _endingScale: number = 0.6;
    private _countUpEffect: PIXI.spine.Spine;

    constructor() {
        super();
        this.init();
        this.position.set(360, 360);
        KarenLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
    }

    protected _waysText: PIXI.Text;

    private set waysText(value: number) {
        this._waysText.text = value.toString() + " " + Translator.translate((value == 1 ? TranslationTexts.WAY_WON : TranslationTexts.WAYS_WON));
        this._waysText.updateTransform();
    }

    public init(): void {
        const style = {
            fontName: KarenGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 120,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._waysText = new PIXI.Text("");
        this._waysText.visible = false;
        this._waysText.style = KarenTextStyles.WAYS_TEXT_COUNTUP_STYLE;
        this._waysText.position = new PIXI.Point(10, 100);
        this._waysText.anchor.set(0.5, 0.5);
        this._countUp = new BitmapCountUp(style);
        this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this._countUpEffect = new PIXI.spine.Spine(Karen.assetLoader.getSpineAsset("countUpEffect"));
        this.addChild(this._countUpEffect, this._waysText, this._countUp);
    }

    public getCountUpAnimation(from: number, to: number, duration: number, multiplier: number, waysText: number = 1): TimelineLite {
        const baseToNumber = multiplier === 1 ? to : MathHelper.roundToDecimals(to / multiplier, 2);
        const tl = gsap.timeline();
        tl.add([
            () => {
                this._countUp.maxTextWidth = this._countUp.maxTextWidth = 600 / this.getScale(multiplier);
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                if (duration > 0.01) {
                    // play count up sound.
                }
            },
            this._countUp.getCountUpAnimation(from, baseToNumber, duration, `power3.inOut`)
        ]);
        this.waysText = waysText;
        this._waysText.position.y = 100;
        // ending stay
        tl.add(this.stay(multiplier));
        tl.add(() => {
            this._waysText.alpha = 1;
            this._waysText.visible = true;
        });
        return tl;
    }

    // #215 - For wins less than base bet dont to the pump up of the win value.
    public showCountUp(to: number, waysText: number = 1): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._countUp.text = to.toFixed(2);
            this.waysText = waysText;
            this._countUp.scale.set(0.6, 0.6);
            this._countUp.pivot.set(this._countUp.width / 2, this._countUp.height / 2);
            this._countUp.alpha = 1;
            this._countUp.visible = true;
            this._waysText.position.set(10, 100);
            this._waysText.alpha = 1;
            this._waysText.visible = true;
        });
        return tl;
    }

    public showCountEffects(anim: string): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._countUpEffect.state.setAnimation(0, anim, false);
        });
        return tl;
    }

    public showToggleWinAmountNWays(singleWin: number, winWaysNumber: number, blink: boolean = false): void {
        const tl: TimelineLite = new TimelineLite();
        this._waysText.alpha = 0;
        this._countUp.alpha = 0;
        if(winWaysNumber===0){
            blink =false;
        }
        if (blink) {
            tl.to([this._waysText, this._countUp], 0.2, {
                alpha: 1, onComplete: () => {
                    this._waysText.alpha = 1;
                    this._countUp.alpha = 1;
                }
            });
        } else {
            this._waysText.alpha = 1;
            this._countUp.alpha = 1;
        }
        if(winWaysNumber===0){
            this._waysText.alpha = 0;
        }
        this.waysText = winWaysNumber;
        this._waysText.visible = true;
        this._waysText.position.set(10, 100);
        this._countUp.fontSize = 120;
        this._countUp.scale.set(0.6);
        this._countUp.text = singleWin.toFixed(2);
        while (this._countUp.textWidth > 680) {
            this._countUp.fontSize--;
        }
        this._countUp.pivot.set(this._countUp.width / 2, this._countUp.height / 2);
        this._countUp.visible = true;
    }

    public hideToggleWinAmountNWays(toFade: boolean): void {
        if (toFade) {
            const duration: number = 0.2,
                tl: TimelineLite = new TimelineLite();

            tl.to([this._waysText, this._countUp], {
                duration: duration,
                alpha: 0,
                onComplete: () => {
                    this._waysText.visible = false;
                    this._countUp.visible = false;
                }
            });
        } else {
            this._waysText.visible = false;
            this._countUp.visible = false;
        }
    }

    public remove(): TimelineLite {
        const tl = gsap.timeline();
        if (this._countUp.visible) {
            this._countUp.text = Karen.model.parsedGameData.singleWin.toFixed(2);
            let totalWinWaysNum = 0;
            (<IBetWayWinData[]>Karen.model.parsedGameData.betWins).forEach((betWayData: IBetWayWinData) => {
                totalWinWaysNum += betWayData.numberOfCombinations;
            });
            this.waysText = totalWinWaysNum;
            tl.add(gsap.to(this._countUp, {
                duration: 0.5,
                alpha: 0,
                y: NolimitApplication.screenBounds.height,
                ease: `power2.in`
            }), `+=0.2`); // stay a short while after count up
            tl.add(gsap.to(this._waysText, {
                duration: 0.35,
                alpha: 0,
                y: NolimitApplication.screenBounds.height - 200,
                ease: `power2.in`
            }), `-=0.4`); // stay a short while after count up.
            tl.add(() => {
                this._countUp.y = 0;
                this._countUp.scale.set(1, 1);
                this._countUp.visible = false;
                this._waysText.y = 0;
                this._waysText.visible = false;
            });
        }

        return tl;
    }

    private getScale(multiplier: number): number {
        let num = 1 + (multiplier - 1) * 0.1;
        return num;
    }

    private stay(multiplier: number): TimelineLite {
        const tl = gsap.timeline();
        tl.add(gsap.to(this._countUp.scale, {
            duration: 0.5,
            x: this.getScale(multiplier) * 1.05,
            y: this.getScale(multiplier) * 1.05,
            ease: `elastic.out(2, 0.75)`
        }));
        tl.add(
            gsap.to(this._countUp.scale, {
                duration: 0.5,
                x: this._endingScale,
                y: this._endingScale,
                ease: `elastic.out(1, 1)`
                // ease: Power4.easeOut
            }));
        return tl;
    }
}
